import { render, staticRenderFns } from "./MusicQuiz.vue?vue&type=template&id=7d57103c&"
import script from "./MusicQuiz.vue?vue&type=script&lang=js&"
export * from "./MusicQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports